import React from "react";

function KeyboardComponent({
  onKeyPress,
  showLetters,
  setShowLetters,
  context,
}) {
  const numbers =
    context === "numeric"
      ? Array.from("123456789-0.")
      : context === "login"
      ? Array.from("123456789@0.")
      : context === "form"
      ? Array.from("123456789-0.@")
      : Array.from("123456789-0_");
  const letters =
    context === "form"
      ? [...Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ"), " "]
      : Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ");
  const keysToShow = showLetters ? letters : numbers;

  const handleKeyClick = (key) => {
    onKeyPress(key);
  };

  return (
    <div className="keypad-container">
      <div
        className="keypad"
        style={{
          gridTemplateColumns: showLetters
            ? "repeat(6, 60px)"
            : "repeat(3, 150px)",
        }}
      >
        {keysToShow.map((key) => (
          <button
            className={key === " " ? "btn btn-secondary key-space" : "btn btn-secondary"}
            key={key === " " ? "space" : key}
            onClick={() => handleKeyClick(key)}
          >
            {key === " " ? "Espace" : key}
          </button>
        ))}
        {context === "numeric" ? (
          <button onClick={() => handleKeyClick("%")}>%</button>
        ) : (
          <button
            className="toggle-keyboard"
            onClick={() => setShowLetters(!showLetters)}
          >
            <i className="fa fa-keyboard"></i>
          </button>
        )}
        <button onClick={() => handleKeyClick("←")}>←</button>
        {context === "numeric" ? (
          <button onClick={() => handleKeyClick("prix")}>Prix</button>
        ) : (
          <button onClick={() => handleKeyClick("✔")}>✔</button>
        )}
      </div>
    </div>
  );
}

export default KeyboardComponent;
